var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.gspn_yn === "Y"
      ? _c("div", {}, [
          _vm.imei_pw.length > 0
            ? _c(
                "div",
                {
                  staticStyle: { "font-size": "1.2em", "font-weight": "bold" }
                },
                [
                  _vm._v(
                    "\n            Current IMEI OTP Password:\n            "
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "inline-block",
                        padding: "4px",
                        border: "3px solid blue",
                        "font-size": "1.3em"
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.imei_pw) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n                Time Remaining(hh:mm:ss)\n            "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "txt_warning" }, [
                    _vm._v(_vm._s(_vm.valid_time))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticStyle: { "font-size": "1.1em" } }, [
            _vm._v(
              "\n            Lost or want to change the IMEI OTP Password?\n            "
            ),
            _c(
              "a",
              {
                staticClass: "btn_white",
                attrs: { href: "javascript:" },
                on: { click: _vm.onReissueClick }
              },
              [_vm._v("Reissue")]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9fc36d64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fc36d64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/certificate/CertOTP.vue
// module id = prws
// module chunks = 0